/**
 * NotFound - real 404 page for the marketing zone catch-all.
 */

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Home as HomeIcon, Explore as ExploreIcon } from '@mui/icons-material';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: { xs: 8, md: 12 },
        }}
      >
        <Typography variant="h1" color="primary" sx={{ fontWeight: 700, lineHeight: 1 }}>
          404
        </Typography>
        <Typography variant="h4" sx={{ mt: 2 }}>
          Page not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1, maxWidth: 480 }}>
          The page you are looking for does not exist or has moved. Let us get you back on track.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4 }}>
          <Button component={RouterLink} to="/" variant="contained" color="primary" startIcon={<HomeIcon />}>
            Back to home
          </Button>
          <Button component={RouterLink} to="/trips" variant="outlined" color="primary" startIcon={<ExploreIcon />}>
            Browse tours
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default NotFound;
